import { Bounds } from "@nens/deck-gl";

import {
  EnormousViz,
  ImagePromise,
  lat2tile,
  loadImage,
  long2tile,
  tile2lat,
  tile2long,
} from "./terrainMain";

export const enormous = async (
  viz: EnormousViz,
  mapBounds: Bounds,
  terrainLayerUrl: string,
  zoom: number,
  nsActive?: boolean
) => {
  const { croppedCanvasNS, croppedCanvasDEM, croppedCtxNS, croppedCtxDem } = viz;
  const imagePromises: ImagePromise[] = [];

  const tLatMap = Math.floor(lat2tile(mapBounds[1], zoom));
  const tLatEndMap = Math.floor(lat2tile(mapBounds[3], zoom));

  const tLongMap = Math.floor(long2tile(mapBounds[0], zoom));
  const tLongEndMap = Math.floor(long2tile(mapBounds[2], zoom));

  // Find the amount of tiles needed in x and y direction
  let tileAmountX = 0;
  let stopX = false;
  while (!stopX) {
    tileAmountX++;
    if (tLongMap + tileAmountX - 1 > tLongEndMap) stopX = true;
  }
  let tileAmountY = 0;
  let stopY = false;
  while (!stopY) {
    tileAmountY++;
    if (tLatMap + tileAmountY - 1 > tLatEndMap) stopY = true;
  }

  // Loop through tiles
  for (let x = 0; x < tileAmountX; x++) {
    const _tLong = tLongMap + (x - 1);
    for (let y = 0; y < tileAmountY; y++) {
      const _tLat = tLatMap + (y - 1);
      // Check if tile is in viewport
      if (tLongMap <= _tLong && _tLong <= tLongEndMap && tLatMap <= _tLat && _tLat <= tLatEndMap) {
        const url = terrainLayerUrl
          .replace("{z}", zoom + "")
          .replace("{x}", _tLong + "")
          .replace("{y}", _tLat + "");

        // Check if NS is active
        if (nsActive) {
          imagePromises.push({
            imagePromise: loadImage(url + "&colormap=ns"),
            x,
            y,
            imageType: "NS",
          });
        }

        imagePromises.push({ imagePromise: loadImage(url), x, y, imageType: "DEM" });
      }
    }
  }

  const images = await Promise.all(imagePromises.map(({ imagePromise }) => imagePromise));

  croppedCtxNS.clearRect(0, 0, croppedCtxNS.canvas.width, croppedCtxNS.canvas.height);
  croppedCtxDem.clearRect(0, 0, croppedCtxDem.canvas.width, croppedCtxDem.canvas.height);

  const widthPixels = tileAmountX * 256;
  const heightPixels = tileAmountY * 256;
  croppedCanvasNS.width = widthPixels;
  croppedCanvasNS.height = heightPixels;
  croppedCanvasDEM.width = widthPixels;
  croppedCanvasDEM.height = heightPixels;

  // Draw new tiles to canvas
  images.forEach((image, index) => {
    const { x, y, imageType } = imagePromises[index];
    (imageType === "NS" ? croppedCtxNS : croppedCtxDem)?.drawImage(image, x * 256, y * 256);
  });

  const newBounds = [
    tile2long(tLongMap - 1, zoom),
    tile2lat(tLatMap - 1, zoom),
    tile2long(tLongMap + tileAmountX - 1, zoom),
    tile2lat(tLatMap + tileAmountY - 1, zoom),
  ] as Bounds;

  return {
    imageNS: croppedCanvasNS,
    imageDEM: croppedCanvasDEM,
    newBounds,
  };
};
